
export const PRIMARY_FONT_COLOR = '#030330'; //Used mostly for General Content, Page Titles, Section Headers, Subsection Headers, Table Column Headers, Table Cell Content, Data Text, Chips, Radio Button Text, Checkbox Text, Hospital Name, Stepper Text, Filters, Active Tabs (when electric blue isn't used)
export const SECONDARY_FONT_COLOR = '#4C4C6C'; //Used mostly for Field/Input Labels, Summary Text, Divider Box Text, Card Text, Hospital Number (in italics), Pagination Text and Numbers, Filter Labels
export const TERTIARY_FONT_COLOR = '#77778F'; //Used mostly for Hint Text in Active Fields, Supportive Helper Text, Inactive Tabs
export const DISABLED_FONT_COLOR = '#B1B1BF'; //Used mostly for Disabled Field Text, Disabled Tab Text, Disabled Radio Button Text, Disabled Checkbox Text, Disabled Pagination Elements
export const WHITE_FONT_COLOR = '#FFFFFF'; // Used for all non-semantic text on a navy background
export const HIGHLIGHT_COLOR= '#ffebbf';//Calendar today highlight color

export const GREEN_FONT_COLOR = '#14853d'; // used for AddedText
export const EVENT_INDICATOR_COLOR='#f26522';// Calendar orange color, no ship text
export const ORANGE_FONT_COLOR = '#b56409'; // used for WarningText
export const TITLE_FONT_COLOR = '#1010eb'; // used title
export const BLACK_FONT_COLOR = '#000000';
export const BLACK_FONT_COLOR2 = '#070707'; // Very dark gray (almost black)
export const DARK_NAVY_FONT_COLOR = '#140F4B'; // Used for Label
export const DARK_GRAY_FONT_COLOR = '#202124'; // used for Segment Tab font color
export const DARK_RED_FONT_COLOR = '#AD0C2ACF'; // Used for Note
export const GRAY_FONT_COLOR = '#4F4F4F'; // Used for Heading
export const RED_FONT_COLOR = '#ED002A'; // Used for Error Message
export const BROWN_FONT_COLOR = '#373737'; // Used for Checkbox Label
export const DISABLED_CHECKBOX_FONT_COLOR = '#8D8D8D'; // Used for disabled Checkbox
export const LIST_VIEW_TABLE_CELL='#3C3C3C';
export const GREY_PRODUCT_LIST_COLOR = '#F5F5F5CC'; // Used for alternate product list in Mobile view
export const BORDER_COLOR = '#EBEDED'; // Used for border in various places
export const DARK_BORDER_COLOR = '#C8C8C8'; // Used for darker border in various places
export const PINK_HIGHLIGHT_COLOR = '#E5057F'; // Used for BOM Change text, discount 
export const RESERVATION_COLOR = '#C121EB'; // Used for Reservation Required text  
export const PARKED_LABEL ='#008d00'; // Used for Parked label text
export const STATUS_TEXT = '#654adc'; // Used for status text
export const GREY_COLOR = '#dedee4';
export const ZEBRA_STRIPE_COLOR = '#fafbfb'; // Used for zebra stripe in tables
//Font Sizes in Pixels
export const XX_SMALL_TEXT_PX = '10px'; //Used sparingly, mostly just for the main navigation on the left column
export const SEMANTIC_TEXT_XSMALL_PX = '11px'; //Used mostly for Error Message
export const X_SMALL_TEXT_PX = '12px'; //Used sparingly for small needs like text on chips, semantic warning messages (BOM Change, Reservation Required, Warning, etc) and for some badge indicators like Tissue and Non-Tissue
export const SEMANTIC_TEXT_SMALL_PX = '13px'; //Used sparingly, mostly for subHeading, Button, CartAction Text
export const SMALL_TEXT_PX = '14px'; //Mostly used for form labels, helper text below form fields (and radio buttons and checkboxes), some gray section headers, stepper labels, some table data, applied filter labels and names, etc.
export const SEMANTIC_TEXT_PX = '15px'; //Used for semantic text like AddedText, WarningText, ErrorText, etc. This is used in the context of semantic text that needs to be slightly larger than the base text size for emphasis.
export const BASE_TEXT_PX = '16px'; //Mostly used for general text, button text, form data text, input field text, hospital name and number text, etc.
export const X_LARGE_TEXT_PX = '20px'; //Used mostly for Header Text
export const LARGE_TEXT_PX = '18px'; //use for Title

// Font Family
export const FONT_FAMILY_DEMI = 'AvenirNextWorld Demi';
export const FONT_FAMILY_REGULAR = 'AvenirNextWorld Regular';
export const FONT_FAMILY_ITALIC = 'AvenirNextWorld Italic';
export const FONT_FAMILY_BOLD = 'AvenirNextWorld Bold';

//
export const CURSOR = 'pointer';
export const DISPLAY = 'block';
export const UNSET = 'unset';
export const NONE = 'none';

/**
 * Z-INDEX SCALE SYSTEM
 * Centralized z-index values for consistent layering across the application.
 * 
 * Scale:
 * - BASE (0-99): Default content
 * - DROPDOWN (100-999): Dropdowns, tooltips
 * - STICKY (1000-1999): Sticky headers, navigation
 * - MODAL_BACKDROP (2000-2999): Modal backdrops
 * - MODAL (3000-3999): Modal dialogs
 * - POPOVER (4000-4999): Popovers over modals
 * - TOAST (5000-5999): Toast notifications
 * - CRITICAL (6000+): Critical UI that must be on top
 */
export const Z_INDEX_BASE = 0;
export const Z_INDEX_DROPDOWN = 100;
export const Z_INDEX_TOOLTIP = 200;
export const Z_INDEX_POPOVER = 300;
export const Z_INDEX_STICKY_HEADER = 1000;
export const Z_INDEX_NAVIGATION = 1100;
export const Z_INDEX_OVERLAY = 2000;
export const Z_INDEX_MODAL_BACKDROP = 2500;
export const Z_INDEX_MODAL = 3000;
export const Z_INDEX_MODAL_DROPDOWN = 4000;
export const Z_INDEX_DATE_PICKER = 5000;
export const Z_INDEX_DATE_PICKER_IN_MODAL = 6000;
export const Z_INDEX_TOAST = 7000;
export const Z_INDEX_CRITICAL_MODAL = 8000;
// Legacy values for backward compatibility
export const Z_INDEX_LEGACY_MODAL = 10000000;
export const Z_INDEX_LEGACY_MOBILE_DROPDOWN = 1000000;


